export enum DateRangeMode {
    ALL = 'forAllTime', WEEK = 'week', MONTH = 'month', CUSTOM = 'custom'
}
